/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps, InspectorControls, RichText } from '@wordpress/block-editor';
import { Panel, PanelBody, PanelRow, CheckboxControl, ColorPalette, ToggleControl, TextControl } from '@wordpress/components';
import { useState, useEffect } from '@wordpress/element';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import '../index.css';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {

	const { categories, card } = attributes

	const [posts, setPosts] = useState()
	const [allCategories, setAllCategories] = useState([])


	useEffect(() => {

		fetch(posts_block.site_url + '/wp-json/wp/v2/categories')
			.then(res => res.json())
			.then(data => setAllCategories(data))
			.catch(error => {
				console.log(error)
				setPosts('error')
			})
	}, [])

	useEffect(() => {

		setPosts([])
		fetch(posts_block.site_url + '/wp-json/wp/v2/posts?per_page=3&categories=' + categories)
			.then(res => res.json())
			.then((data) => {

				setPosts(data)
			})
			.catch(error => {
				console.log(error)
				setPosts('error')
			})

	}, [categories])



	return (
		<div {...useBlockProps()}>
			<InspectorControls>
				<Panel>
					<PanelBody>
						<PanelRow>
							<div>
								<div style={{ marginTop: "1rem", marginBottom: "0.4rem", textTransform: "uppercase", fontSize: "11px", fontWeight: "500", lineHeight: "1.4" }}>
									Posts Categories
								</div>
								{allCategories?.map((c) => {
									return (
										<CheckboxControl
											label={c?.name || ""}
											checked={categories?.indexOf(c?.id) > -1}
											onChange={(value) => {

												const index = categories?.indexOf(c?.id)
												if (value) {
													if (index === -1) {
														const newArray = [...categories]
														newArray[newArray.length] = c?.id
														setAttributes({ categories: newArray })
													}
												} else {
													if (index > -1) {
														const newArray = [...categories]
														newArray.splice(index, 1)
														setAttributes({ categories: newArray })
													}
												}

											}}
										/>
									)
								})}
							</div>
						</PanelRow>


						<div style={{ marginTop: "1rem", marginBottom: "0.4rem", textTransform: "uppercase", fontSize: "11px", fontWeight: "500", lineHeight: "1.4" }}>
							Color of title and caption
						</div>
						<ColorPalette
							value={card?.color || ""}
							colors={[
								{
									color: '#F6D033',
									name: 'Yellow'
								},
								{
									color: '#386BBF',
									name: 'Blue'
								}
							]}
							clearable={false}
							onChange={(color) => setAttributes({ card: { ...card, color } })}
							disableCustomColors={true}
						/>



						<div style={{ marginTop: "1rem", marginBottom: "0.4rem", textTransform: "uppercase", fontSize: "11px", fontWeight: "500", lineHeight: "1.4" }}>
							Title, caption, text and button
						</div>
						<ToggleControl
							checked={card?.titleEnabled || false}
							label="Show title"
							onChange={titleEnabled => setAttributes({ card: { ...card, titleEnabled } })}
						/>

						<ToggleControl
							checked={card?.captionEnabled || false}
							label="Show caption"
							onChange={captionEnabled => setAttributes({ card: { ...card, captionEnabled } })}
						/>

						<ToggleControl
							checked={card?.textEnabled || false}
							label="Show text"
							onChange={textEnabled => setAttributes({ card: { ...card, textEnabled } })}
						/>

						<ToggleControl
							checked={card?.buttonEnabled || false}
							label="Show button"
							onChange={buttonEnabled => setAttributes({ card: { ...card, buttonEnabled } })}
						/>

						<TextControl
							value={card?.button}
							label="Button text"
							onChange={button => setAttributes({ card: { ...card, button } })}
						/>

					</PanelBody>
				</Panel>
			</InspectorControls>

			<div>

				{posts && posts.length !== undefined && posts.length === 0 && (
					<p>loading posts...</p>
				)}

				{posts && posts.length === undefined && (
					<p>[error] no posts with this category </p>
				)}

				{posts && posts.length > 0 && (
					<p>showing posts with
						{
							categories.length === 1 ? " category " : " categories "
						}
						{
							allCategories?.map((c, index) => {
								if (categories?.indexOf(c?.id) > -1) {

									if (categories.length === 1) {
										return <span className="font-bold">{c?.name}</span>
									} else {
										return <>{index !== 0 ? "," : ""} <span className="font-bold">{c?.name}</span></>
									}

								} else {
									return <></>
								}
							})
						}
					</p>
				)}



			</div>
		</div>
	);
}
